import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e8d0ffb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "main" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "h1" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "content"
}
const _hoisted_7 = { class: "title" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "desc" }
const _hoisted_10 = {
  key: 1,
  class: "not"
}

import http from "@/api/index";
import { reactive, ref, watch } from "vue";
import * as types from "@/api/search/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const searchText = ref("");
const searchEnterLock = ref(false);
const loadingState = ref({
    baidu: {
        loading: false,
        pageIndex: 1
    },
    bing: {
        loading: false,
        pageIndex: 1
    },
    google: {
        loading: false,
        pageIndex: 1
    }
});
const loading = ref(false);

function loadingReady() {
    const data: any = loadingState.value;
    for (const key in data) {
        if (data[key].loading) {
            return true;
        }
    }
    return false;
}
watch(
    () => loadingState.value,
    () => {
        loading.value = loadingReady();
    },
    { deep: true }
);

function keyDown(event: KeyboardEvent) {
    if (event.keyCode != 13 || searchEnterLock.value) {
        return;
    }
    searchEnterLock.value = true;
    search();
}

function keyUp(event: KeyboardEvent) {
    if (event.keyCode != 13) {
        return;
    }
    searchEnterLock.value = false;
}

function search() {
    baidu();
    bing();
    google();
}

const fns = {
    baidu,
    bing,
    google
};

const allSearchData = ref<Array<types.ISearchResult>>([]);

async function baidu() {
    loadingState.value.baidu.loading = true;
    allSearchData.value[0] = await http.search.baidu({
        keywords: searchText.value,
        pageIndex: loadingState.value.baidu.pageIndex
    });
    allSearchData.value[0].name = "baidu";
    allSearchData.value[0].pageIndex = loadingState.value.baidu.pageIndex;
    loadingState.value.baidu.loading = false;
    console.log("🚀 百度数据", allSearchData.value[0]);
}

async function bing() {
    loadingState.value.bing.loading = true;
    allSearchData.value[1] = await http.search.bing({
        keywords: searchText.value,
        pageIndex: allSearchData.value[1]
            ? allSearchData.value[1].pageNum[loadingState.value.bing.pageIndex]
            : 1
    });
    allSearchData.value[1].name = "bing";
    allSearchData.value[1].pageIndex = loadingState.value.bing.pageIndex;
    loadingState.value.bing.loading = false;
    console.log("🚀 Bing数据", allSearchData.value[1]);
}

async function google() {
    loadingState.value.google.loading = true;
    allSearchData.value[2] = await http.search.google({
        keywords: searchText.value,
        pageIndex: loadingState.value.google.pageIndex
    });
    allSearchData.value[2].name = "google";
    allSearchData.value[2].pageIndex = loadingState.value.google.pageIndex;
    loadingState.value.google.loading = false;
    console.log("🚀 google数据", allSearchData.value[2]);
}

function changePage(index: number, type: string) {
    if (index == 0) return;
    const data = loadingState.value as any;
    data[type].pageIndex = index;
    const fnsCache = fns as any;
    fnsCache[type]();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["searchInput", {
                hasText: allSearchData.value.length > 0
            }])
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "Search？🔍",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
        onKeydown: keyDown,
        onKeyup: keyUp
      }, null, 544), [
        [_vModelText, searchText.value]
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["enter", {
                    enterDown: searchEnterLock.value,
                    enterShow: searchText.value != '' && !loading.value
                }]),
        onClick: search
      }, " Enter! ", 2)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["searchResult", {
                searchResultShow: allSearchData.value.length > 0
            }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allSearchData.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          item
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", null, _toDisplayString(item.name) + " " + _toDisplayString(item.size) + " 条", 1),
                  _createElementVNode("span", null, [
                    _createElementVNode("span", null, "当前页：" + _toDisplayString(item.pageIndex), 1),
                    _createElementVNode("span", {
                      class: _normalizeClass(["click", {}]),
                      onClick: ($event: any) => (
                                    changePage(item.pageIndex - 1, item.name)
                                )
                    }, "上一页", 8, _hoisted_4),
                    _createElementVNode("span", {
                      class: "click",
                      onClick: ($event: any) => (
                                    changePage(item.pageIndex + 1, item.name)
                                )
                    }, "下一页", 8, _hoisted_5)
                  ])
                ]),
                (item.rows.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.rows, (item2, index2) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "item",
                          key: index2
                        }, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("a", {
                              href: item2.link,
                              target: "_blank"
                            }, _toDisplayString(item2.title), 9, _hoisted_8)
                          ]),
                          _createElementVNode("div", _hoisted_9, _toDisplayString(item2.content), 1)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, "暂无"))
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ], 2)
  ]))
}
}

})